import { render, staticRenderFns } from "./SetUpCompanyProduct.vue?vue&type=template&id=dc8b2cea&"
import script from "./SetUpCompanyProduct.vue?vue&type=script&lang=js&"
export * from "./SetUpCompanyProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports